/* gr-header.js — Header interactivity.
 *   - Announcement rotation
 *   - Mobile menu open/close
 *   - Search modal open/close + focus
 *   - Hide-on-scroll (optional setting)
 *   - Sync cart count with /cart.js on load
 */
(function () {
  'use strict';

  // ── Focus trap helper (shared via window.GR.trapFocus) ────
  // Intercepts Tab/Shift+Tab inside `container` so focus can't leak to the
  // background. Returns a release() that detaches the listener and restores
  // focus to whatever was active when trapFocus was called. Used by the
  // mobile menu, search modal, and cart drawer.
  var FOCUSABLE_SEL = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function trapFocus(container) {
    var triggerEl = document.activeElement;
    function getFocusable() {
      return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SEL))
        .filter(function (el) { return el.offsetParent !== null && !el.closest('[hidden],[aria-hidden="true"]'); });
    }
    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      var fs = getFocusable();
      if (!fs.length) { e.preventDefault(); return; }
      var first = fs[0];
      var last  = fs[fs.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    container.addEventListener('keydown', onKeydown);
    return function release() {
      container.removeEventListener('keydown', onKeydown);
      if (triggerEl && typeof triggerEl.focus === 'function') {
        try { triggerEl.focus(); } catch (e) {}
      }
    };
  }
  window.GR = window.GR || {};
  window.GR.trapFocus = trapFocus;

  // ── Announcement rotation ─────────────────────────────────
  var ann = document.querySelector('.gr-announce');
  if (ann) {
    var items = ann.querySelectorAll('.gr-announce__item');
    var interval = parseInt(ann.dataset.interval, 10) || 4500;
    if (items.length > 1) {
      var i = 0;
      setInterval(function () {
        items[i].removeAttribute('data-active');
        i = (i + 1) % items.length;
        items[i].setAttribute('data-active', '');
      }, interval);
    }
  }

  // ── Mobile menu ───────────────────────────────────────────
  var menu = document.getElementById('gr-mobile-menu');
  var ham  = document.querySelector('[data-gr-ham]');
  if (menu && ham) {
    var releaseMenuTrap = null;
    var openMenu = function () {
      menu.setAttribute('aria-hidden', 'false');
      ham.setAttribute('aria-expanded', 'true');
      document.body.classList.add('gr-cart-open');
      releaseMenuTrap = trapFocus(menu);
      // trapFocus only intercepts Tab; move initial focus into the menu so
      // keyboard/SR users land inside it (release() restores focus to the ham).
      // Target the close button specifically — the scrim also carries
      // data-gr-ham-close but is a non-focusable <div>.
      var closeBtn = menu.querySelector('.gr-mobile-menu__close');
      if (closeBtn) {
        try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
      }
    };
    var closeMenu = function () {
      menu.setAttribute('aria-hidden', 'true');
      ham.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('gr-cart-open');
      if (releaseMenuTrap) { releaseMenuTrap(); releaseMenuTrap = null; }
    };
    ham.addEventListener('click', openMenu);
    menu.querySelectorAll('[data-gr-ham-close]').forEach(function (n) {
      n.addEventListener('click', closeMenu);
    });
    menu.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') closeMenu();
    });

    // Sub-menu toggles
    menu.querySelectorAll('[data-gr-mobile-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.closest('.gr-mobile-menu__item');
        var sub = item.querySelector('.gr-mobile-menu__sub');
        if (!sub) return;
        var isOpen = !sub.hidden;
        sub.hidden = isOpen;
        item.classList.toggle('is-open', !isOpen);
      });
    });
  }

  // ── Search modal ──────────────────────────────────────────
  var search = document.getElementById('gr-search-modal');
  if (search) {
    var input = search.querySelector('[data-gr-search-input]');
    var releaseSearchTrap = null;
    var openSearch = function () {
      search.setAttribute('aria-hidden', 'false');
      releaseSearchTrap = trapFocus(search);
      setTimeout(function () { if (input) input.focus(); }, 240);
    };
    var closeSearch = function () {
      search.setAttribute('aria-hidden', 'true');
      if (releaseSearchTrap) { releaseSearchTrap(); releaseSearchTrap = null; }
    };
    document.querySelectorAll('[data-gr-search-open]').forEach(function (n) {
      n.addEventListener('click', openSearch);
    });
    search.querySelectorAll('[data-gr-search-close]').forEach(function (n) {
      n.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && search.getAttribute('aria-hidden') === 'false') closeSearch();
    });
  }

  // ── Hide-on-scroll ───────────────────────────────────────
  var header = document.querySelector('.gr-header');
  if (header && header.dataset.hideOnScroll === 'true') {
    var lastY = window.scrollY;
    var threshold = 10;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 120 && y - lastY > threshold) header.classList.add('gr-header--hidden');
      else if (lastY - y > threshold || y < 120) header.classList.remove('gr-header--hidden');
      lastY = y;
    }, { passive: true });
  }

  // ── Cart count sync (header mirrors drawer count) ─────────
  var countEls = document.querySelectorAll('[data-gr-cart-count]');
  if (countEls.length) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { countEls.forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }
})();
